export default {
    seasonTypes: [
        { value: 'S', name: 'Spring' },
        { value: 'R', name: 'Regular Season' },
        { value: 'F', name: 'Wild Card' },
        { value: 'D', name: 'Division Series' },
        { value: 'L', name: 'Championship Series' },
        { value: 'W', name: 'World Series' },
    ],
    plateAppearanceResults: [
        { value: 'single', name: 'Single' },
        { value: 'double', name: 'Double' },
        { value: 'triple', name: 'Triple' },
        { value: 'home_run', name: 'Home Run' },
        { value: 'strikeout', name: 'Strikeout' },
        { value: 'strikeout_double_play', name: 'Strikeout Double Play' },
        { value: 'walk', name: 'Walk' },
        { value: 'double_play', name: 'Double Play' },
        { value: 'error', name: 'Error' },
        { value: 'field_error', name: 'Field Error' },
        { value: 'fielders_choice', name: 'Fielders Choice' },
        { value: 'fielders_choice_out', name: 'Fielders Choice - Out' },
        { value: 'field_out', name: 'Field Out' },
        { value: 'force_out', name: 'Force Out' },
        { value: 'grounded_into_double_play', name: 'Ground Into Double Play' },
        { value: 'hit_by_pitch', name: 'Hit By Pitch' },
        { value: 'in_progress', name: 'In Progress' },
        { value: 'sac_bunt', name: 'Sac Bunt' },
        { value: 'sac_bunt_double_play', name: 'Sac Bunt - Double Play' },
        { value: 'sac_fly', name: 'Sac Fly' },
        { value: 'sac_fly_double_play', name: 'Sac Fly - Double Play' },
    ],
    pitchTypes: [
        { value: 'FF', name: '4-Seam Fastball' },
        { value: 'FT', name: '2-Seam Fastball' },
        { value: 'FC', name: 'Cutter' },
        { value: 'SI', name: 'Sinker' },
        { value: 'FS', name: 'Split-Finger' },
        { value: 'SL', name: 'Slider' },
        { value: 'CH', name: 'Changeup' },
        { value: 'CU', name: 'Curveball' },
        { value: 'KC', name: 'Knuckle Curve' },
        { value: 'KN', name: 'Knuckleball' },
        { value: 'FO', name: 'Forkball' },
        { value: 'EP', name: 'Eephus' },
        { value: 'SC', name: 'Screwball' },
        { value: 'AB', name: 'Automatic' },
        { value: 'CS', name: 'Curveball' },
        { value: 'FA', name: 'Fastball' },
        { value: 'IN', name: 'Intentional' },
        { value: 'PO', name: 'Pitchout' },
        { value: 'UN', name: 'Unknown' },
    ],
    pitchResult: [
        { value: 'hit_into_play', name: 'Hit into Play' },
        { value: 'ball', name: 'Ball' },
        { value: 'blocked_ball', name: 'Blocked Ball In Dirt' },
        { value: 'called_strike', name: 'Called Strike' },
        { value: 'swinging_strike', name: 'Swinging Strike' },
        { value: 'swinging_strike_blocked', name: 'Swinging Strike in Dirt' },
        { value: 'swinging_pitchout', name: 'Swinging Pitchout' },
        { value: 'missed_bunt', name: 'Missed Bunt' },
        { value: 'bunt_foul_tip', name: 'Foul Tip Bunt' },
        { value: 'foul', name: 'Foulball' },
        { value: 'foul_bunt', name: 'Foul - Bunt' },
        { value: 'foul_tip', name: 'Foul Tip' },
        { value: 'foul_pitchout', name: 'Foul Pitchout' },
        { value: 'hit_by_pitch', name: 'Hit by Pitch' },
        { value: 'pitchout', name: 'Pitchout' },
    ],
    // Do we want to add?
    // ['Automatic Ball', 'automatic..ball'],
    // ['Automatic Strike', 'automatic..strike'],
    // ['Intent Ball', 'intent..ball'],
}
